export default {
  stato: {
    bozza: 0,
    compilata: 1,
    inviata: 2,
    vincitore: 3,
    non_vincitore: 4,

  },
  /**
   * mappa gli stati flusso per dare un colore al pallino per utente
   * @type {Object}
   */
  pallini: {
    ente: {
      green: [0, 1],
      red: [3],
      orange: [2]
    },
    dirigente: {
      green: [],
      red: [3],
      orange: [0, 1]
    },
    istruttore: {
      green: [2],
      red: [],
      orange: []
    },
    ispettore: {
      green: [],
      red: [],
      orange: []
    }
  },

  tipo_finanziamento: {
    finanziato: 1,
    autofinanziato: 2
  },

  getStatoLabel: (domanda) => {
    let label = '';
    let stato = domanda.stato || domanda;
    switch (stato) {
      case 0: label = 'Bozza'; break;
      case 1: label = 'Compilata'; break;
      case 2: label = 'Inviata'; break;
      case 3: label = 'Vincitore'; break;
      case 4: label = 'Non vincitore'; break;
      default: break;
    }
    return label;
  },

  stato_procedura: {
    attivo: 0,
    aperto: 1,
    chiuso: 2
  },

  stato_progetto: {
    registrato: 0,
    predisposizione: 1,
    presentato: 2,
    assegnato: 3,
    istruttoria: 4,
    avvio_sospeso: 5,
    rigettato: 6,
    avvio_progetto: 7,
    iscrizioni_aperte: 8,
    iscrizioni_chiuse: 9,
    erogazione: 10,
    completato: 11,
    revoca_corso: 12,
    sospensione_corso: 13
  },

  stato_flusso_progetto: {
    registrato: 0,
    predisposizione: 1,
    compilato: 2,
    firmato: 3,
    presentato: 4,
    assegnato: 5,
    istruttoria: 6,
    audit_iniziato: 7,
    sospeso: 8,
    integrazioni: 9,
    comunicazione_ostativa_richiesta: 10,
    comunicazione_ostativa_inviata: 11,
    controdeduzioni_inviate: 12,
    rigetto_predisposto: 13,
    rigettato: 14,
    avvio_progetto_predisposto: 15,
    registrazione_necessaria: 16,
    preparazione_registrazioni: 17,
    approvazione_registrazioni: 18,
    registrazioni_confermate: 19,
    attesa_apertura_iscrizioni: 20,
    registrazioni_aperte: 21,
    corso_in_preparazione: 22,
    corso_pronto_all_avvio: 23,
    corso_in_erogazione: 24,
    ispezione_necessaria: 25,
    attesa_ispettori: 26,
    progetto_completato: 27,
    visita_ispettiva: 28,
    verbale_firmato: 29,
    attesa_esito: 30,
    corso_sospeso: 31,
    revoca_corso: 32,
    conferma_sospeso: 33,
    conferma_revoca: 34
  },

  /**
   * mappa gli stati flusso del progetto per dare un colore al pallino per utente
   * @type {Object}
   */

  getPallino(user, c, stato) {

    let pallini = {
      dirigente: {
        green: [this.stato_flusso_progetto.presentato,
        this.stato_flusso_progetto.sospeso,
        this.stato_flusso_progetto.comunicazione_ostativa_richiesta,
        this.stato_flusso_progetto.rigetto_predisposto,
        this.stato_flusso_progetto.avvio_progetto_predisposto,
        this.stato_flusso_progetto.corso_in_erogazione,
        this.stato_flusso_progetto.ispezione_necessaria,
        this.stato_flusso_progetto.corso_sospeso,
        this.stato_flusso_progetto.revoca_corso,
        this.stato_flusso_progetto.conferma_revoca,
        this.stato_flusso_progetto.approvazione_registrazioni,
        this.stato_flusso_progetto.conferma_sospeso
        ],
        red: [this.stato_flusso_progetto.assegnato,
        this.stato_flusso_progetto.istruttoria,
        this.stato_flusso_progetto.audit_iniziato,
        this.stato_flusso_progetto.integrazioni,
        this.stato_flusso_progetto.comunicazione_ostativa_inviata,
        this.stato_flusso_progetto.controdeduzioni_inviate,
        this.stato_flusso_progetto.registrazione_necessaria,
        this.stato_flusso_progetto.preparazione_registrazioni,
        this.stato_flusso_progetto.registrazioni_chiuse,
        this.stato_flusso_progetto.attesa_ispettori,
        this.stato_flusso_progetto.visita_ispettiva,
        this.stato_flusso_progetto.verbale_firmato,
        this.stato_flusso_progetto.attesa_esito
        ],
      },
      istruttore: {
        green: [this.stato_flusso_progetto.assegnato,
        this.stato_flusso_progetto.istruttoria,
        this.stato_flusso_progetto.audit_iniziato,
        this.stato_flusso_progetto.controdeduzioni_inviate,
        this.stato_flusso_progetto.preparazione_registrazioni,
        this.stato_flusso_progetto.attesa_esito
        ],
        red: [this.stato_flusso_progetto.sospeso,
        this.stato_flusso_progetto.integrazioni,
        this.stato_flusso_progetto.comunicazione_ostativa_richiesta,
        this.stato_flusso_progetto.comunicazione_ostativa_inviata,
        this.stato_flusso_progetto.rigetto_predisposto,
        this.stato_flusso_progetto.avvio_progetto_predisposto,
        this.stato_flusso_progetto.registrazione_necessaria,
        this.stato_flusso_progetto.registrazioni_chiuse,
        this.stato_flusso_progetto.ispezione_necessaria,
        this.stato_flusso_progetto.attesa_ispettori,
        this.stato_flusso_progetto.visita_ispettiva,
        this.stato_flusso_progetto.verbale_firmato,
        this.stato_flusso_progetto.approvazione_registrazioni
        ],
      },
      ente: {
        green: [this.stato_flusso_progetto.registrato,
        this.stato_flusso_progetto.predisposizione,
        this.stato_flusso_progetto.compilato,
        this.stato_flusso_progetto.firmato,
        this.stato_flusso_progetto.integrazioni,
        this.stato_flusso_progetto.comunicazione_ostativa_inviata,
        this.stato_flusso_progetto.registrazione_necessaria,
        this.stato_flusso_progetto.registrazioni_chiuse,
        this.stato_flusso_progetto.verbale_firmato,
        this.stato_flusso_progetto.registrazioni_confermate,
        this.stato_flusso_progetto.corso_in_preparazione
        ],
        red: [this.stato_flusso_progetto.presentato,
        this.stato_flusso_progetto.assegnato,
        this.stato_flusso_progetto.istruttoria,
        this.stato_flusso_progetto.audit_iniziato,
        this.stato_flusso_progetto.sospeso,
        this.stato_flusso_progetto.comunicazione_ostativa_richiesta,
        this.stato_flusso_progetto.controdeduzioni_inviate,
        this.stato_flusso_progetto.rigetto_predisposto,
        this.stato_flusso_progetto.avvio_progetto_predisposto,
        this.stato_flusso_progetto.preparazione_registrazioni,
        this.stato_flusso_progetto.attesa_esito,
        this.stato_flusso_progetto.corso_sospeso,
        this.stato_flusso_progetto.revoca_corso,
        this.stato_flusso_progetto.approvazione_registrazioni,
        this.stato_flusso_progetto.conferma_sospeso
        ],
      },
      ispettore: {
        green: [this.stato_flusso_progetto.ispezione_necessaria,
        this.stato_flusso_progetto.attesa_ispettori,
        this.stato_flusso_progetto.visita_ispettiva],
        red: [],
      }
    }

    return pallini[user][c].indexOf(stato);

  },


  tipo_media: {
    sottodominio_dichiarazione_accettazione_firmata: 'dichiarazione_accettazione_firmata',
    sottodominio_comunicazione_ostativa: 'comunicazione_ostativa_istruttore',
    sottodominio_decreto_autorizzativo: 'decreto_autorizzativo',
    sottodominio_richiesta_pubblicizzazione_corso: 'richiesta_pubblicizzazione_corso'
  },

  getProgettoLabel: (stato, isEnte) => {
    let label = '';
    switch (stato) {
      case 0: label = 'Registrato'; break;
      case 1: label = 'In predisposizione'; break;
      case 2: label = 'Presentato'; break;
      case 3: label = isEnte ? 'Presentato' : 'Assegnato'; break;
      case 4: label = isEnte ? 'Presentato' : 'In istruttoria'; break;
      case 5: label = 'Avvio sospeso'; break;
      case 6: label = 'Rigettato'; break;
      case 7: label = 'Avvio progetto'; break;
      case 8: label = 'Iscrizioni aperte'; break;
      case 9: label = 'Iscrizioni chiuse'; break;
      case 10: label = 'Erogazione'; break;
      case 11: label = 'Completato'; break;
      case 12: label = 'Revoca corso'; break;
      case 13: label = 'Sospensione corso'; break;
      default: break;
    }
    return label;
  },

  stato_iscrizione: {
    bozza: 0,
    compilata: 1,
    inviata: 2,
    idoneo: 3,
    non_idoneo: 4,
    abbandonato: 5,
    in_attesa: 6,
    iscritto: 7,
    attesa_giustificativo:8,
    espulso: 9,
  },

  stato_flusso_iscrizione: {
    invitato: 0,
    sospeso: 1,
    accettato: 2,
    convocazione_inviata: 3,
    convocazione_sospesa: 4,
    rifiutato: 5,
    iscritto: 6,
    attesa_giustificativo: 7,
  },

  getStatoIscrizioneLabel(stato) {
    let label = '';
    switch (stato) {
      case this.stato_iscrizione.bozza:
        label = 'Bozza'; break;
      case this.stato_iscrizione.compilata:
        label = 'Compilata'; break;
      case this.stato_iscrizione.inviata:
        label = 'Inviata'; break;
      case this.stato_iscrizione.idoneo:
        label = 'Idoneo'; break;
      case this.stato_iscrizione.non_idoneo:
        label = 'Non idoneo'; break;
      case this.stato_iscrizione.abbandonato:
        label = 'Abbandonato'; break;
      case this.stato_iscrizione.in_attesa:
        label = 'In attesa'; break;
      case this.stato_iscrizione.iscritto:
        label = 'Iscritto'; break;
      case this.stato_iscrizione.espulso:
        label = 'Espulso'; break;
      case this.stato_iscrizione.attesa_giustificativo:
        label = 'Sospeso'; break;
      default: break;
    }
    return label;
  },

  getStatoFlussoIscrizioneLabel(stato_flusso) {
    let label = '';
    switch (stato_flusso) {
      case this.stato_flusso_iscrizione.invitato:
        label = 'Invitato'; break;
      case this.stato_flusso_iscrizione.sospeso:
        label = 'Invito sospeso'; break;
      case this.stato_flusso_iscrizione.accettato:
        label = 'Invito accettato'; break;
      case this.stato_flusso_iscrizione.convocazione_inviata:
        label = 'Convocazione inviata'; break;
      case this.stato_flusso_iscrizione.convocazione_sospesa:
        label = 'Convocazione sospesa'; break;
      case this.stato_flusso_iscrizione.rifiutato:
        label = 'Rifiutato'; break;
      case this.stato_flusso_iscrizione.iscritto:
        label = 'Contratto firmato'; break;
      case this.stato_flusso_iscrizione.attesa_giustificativo:
        label = 'Sospeso'; break;
      default: break;
    }
    return label;
  },

  stato_docente: {
    attivo: 0,
    sostituito: 1,
  },

  getStatoDocenteLabel(stato) {
    let label = '';
    switch (stato) {
      case this.stato_docente.attivo:
        label = 'Attivo'; break;
      case this.stato_docente.sostituito:
        label = 'Sostituito'; break;
      default: break;
    }
    return label;
  }

}
